export default "__VITE_ASSET__DxqUG14d__"